/*
 * Turns the footer menu headings into disclosure buttons below 750px and
 * leaves them as plain headings above it.
 *
 * The collapsed state and its transition live entirely in CSS
 * (grid-template-rows 0fr -> 1fr), so the lists are already shut on the first
 * paint. This only flips the state attributes on click and re-opens
 * everything when the viewport crosses into the desktop layout.
 */
if (!customElements.get('footer-menu-accordion')) {
  customElements.define(
    'footer-menu-accordion',
    class FooterMenuAccordion extends HTMLElement {
      constructor() {
        super();
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.onToggleClick = this.onToggleClick.bind(this);
        this.onBreakpointChange = this.onBreakpointChange.bind(this);
      }

      connectedCallback() {
        this.toggles = Array.from(this.querySelectorAll('.footer-block__toggle'));
        if (this.toggles.length === 0) return;

        this.toggles.forEach((toggle) => toggle.addEventListener('click', this.onToggleClick));
        this.mediaQuery.addEventListener('change', this.onBreakpointChange);
        this.syncToBreakpoint();
      }

      disconnectedCallback() {
        if (!this.toggles) return;
        this.toggles.forEach((toggle) => toggle.removeEventListener('click', this.onToggleClick));
        this.mediaQuery.removeEventListener('change', this.onBreakpointChange);
      }

      onBreakpointChange() {
        this.syncToBreakpoint();
      }

      /* Collapsed on a phone, always open from tablet up. */
      syncToBreakpoint() {
        const expanded = !this.mediaQuery.matches;
        this.toggles.forEach((toggle) => this.setExpanded(toggle, expanded));
      }

      onToggleClick(event) {
        if (!this.mediaQuery.matches) return;
        const toggle = event.currentTarget;
        this.setExpanded(toggle, toggle.getAttribute('aria-expanded') !== 'true');
      }

      setExpanded(toggle, expanded) {
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.closest('.footer-block').classList.toggle('footer-block--expanded', expanded);
      }
    }
  );
}
